"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pTimeout = exports.invokeCallback = void 0;
var analytics_core_1 = require("@segment/analytics-core");
Object.defineProperty(exports, "invokeCallback", { enumerable: true, get: function () { return analytics_core_1.invokeCallback; } });
Object.defineProperty(exports, "pTimeout", { enumerable: true, get: function () { return analytics_core_1.pTimeout; } });
//# sourceMappingURL=index.js.map